import { Injectable, Injector } from "@angular/core";
import { Observable, catchError, of } from "rxjs";
import { SdkBase } from "../utilities/sdk-base/sdk.base";
import { Prompt } from "../models/prompt.model";

@Injectable({ providedIn: 'root' })
export class PromptSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getPrompts(searchTerm: string): Observable<Prompt[] | null> {
		let query = '';
		if (searchTerm && searchTerm?.length > 0)
			query = `?searchTerm=${searchTerm}`
		return this.makeHttpRequest<Prompt[]>('get', `api2/prompts${query}`).pipe(
			catchError(() => {
				return of(null);
			}));
	}

	public get(promptId: string): Observable<Prompt | null> {
		return this.makeHttpRequest<Prompt>('get', `api2/prompts/${promptId}`).pipe(
			catchError(() => {
				return of(null);
			}));
	}

	public getSummaryPrompt(): Observable<Prompt[] | null> {
		return this.makeHttpRequest<Prompt[]>('get', `api2/prompts/summary`).pipe(
			catchError(() => {
				return of(null);
			}));
	}

	public post(title: string, fullPrompt: string): Observable<Prompt | null> {
		return this.makeHttpRequest<Prompt>('post', `api2/prompts`, { title: title, fullPrompt: fullPrompt }).pipe(
			catchError(() => {
				console.log('error danger ranger')
				return of(null);
			}));
	}

	public patch(promptId: string, deltaPrompt: Partial<Prompt>): Observable<Prompt | null> {
		const body = [];
		for (const key in deltaPrompt) {
			body.push({
				op: "replace",
				path: `/${key}`,
				value: deltaPrompt[key]
			})
		}
		return this.makeHttpRequest<Prompt>('patch', `api2/prompts/${promptId}`, body);
	}

	public delete(promptId: string): Observable<boolean | null> {
		return this.makeHttpRequest<boolean>('delete', `api2/prompts/${promptId}`).pipe(
			catchError(() => {
				return of(null);
			}));
	}
}
